<template>
  <div class="">
    <Navbar />

    <div id="main">
      <div class="container">
        <div class="row align-items-center" style="background:#000;">
          <div class="col-md-12 p-0" v-lazy-container="{ selector: 'img' }">
            <img data-src="/logo/modelssubmission.png" data-loading="/logo/modelssubmission.png"
              style="width:100%;max-height:495px;object-fit: cover;">
          </div>
        </div>
      </div>

      <div class="container">
        <div class="row">
          <div id="detail" style="min-height:200px; background: linear-gradient(#1b1b1b, #4e4e4e); color:#fff;">
            <div class="text-center mb-4">
              <h2 class="py-2" style="color:#fff;">On-Camera Commercial Talent and Models </h2>
            </div>

            <div id="desc" class="text-center" style="line-height: 1.8em; align:justify;">
              <small>IDIOM represents a select group of on-camera and print talent, focusing primarily on high-end and
                prominent commercial brands and events. We are currently seeking female and male runway-style models and
                commercial talent aged 23-55 years old, with unique character traits being a plus.
                If you are seeking on-camera commercial or print representation, we are actively searching for talent in
                the regions of Los Angeles, California, Florida, Texas, and Oahu, Hawaii. Please share a bit about
                yourself and submit your headshots or photographs.</small>
            </div>

            <form class="row my-5" @submit.prevent="submitForm">
              <!-- <div class="col-12 text-center my-4">
                <h3>Your Information</h3>
              </div> -->
              <div class="col-12">
                <div class="form-row">
                  <div class="form-group col-md-4">
                    <label>Firstname <font color="red">*</font></label>
                    <div :class="{ 'control is-loading': processing }">
                      <input type="text" class="form-control" placeholder="Firstname" v-model="fname"
                        :disabled="processing" required>
                    </div>
                  </div>
                  <div class="form-group col-md-4">
                    <label>Lastname <font color="red">*</font></label>
                    <div :class="{ 'control is-loading': processing }">
                      <input type="text" class="form-control" placeholder="Lastname" v-model="lname"
                        :disabled="processing" required>
                    </div>
                  </div>
                  <div class="form-group col-md-4">
                    <label>Gender <font color="red">*</font></label>
                    <div :class="{ 'control is-loading': processing }">
                      <select class="form-control" v-model="gender" :disabled="processing" required>
                        <option value="" selected disabled>Select Gender</option>
                        <option value="1">Male</option>
                        <option value="2">Female</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-md-4">
                    <label>Email <font color="red">*</font></label>
                    <div :class="{ 'control is-loading': processing }">
                      <input type="email" class="form-control" placeholder="Email" v-model="email" :disabled="processing"
                        required>
                    </div>
                  </div>
                  <div class="form-group col-md-4">
                    <label>Age Range <font color="red">*</font></label>
                    <div :class="{ 'control is-loading': processing }">
                      <select class="form-control" v-model="age_range_str" :disabled="processing" required>
                        <option value="" selected disabled>Age Range</option>
                        <option v-for="(val, key) in age_range" :key="key" :value="val">{{ val.title }}</option>
                      </select>
                    </div>
                  </div>
                  <div class="form-group col-md-4">
                    <label>Ethnicity <font color="red">*</font></label>
                    <div :class="{ 'control is-loading': processing }">
                      <!-- <multiselect ref="ethnicity_str" v-model="ethnicity_str" :options="ethnicities" placeholder="Ethnicities..." label="name" track-by="id" :multiple="true" :disabled="processing"></multiselect> -->
                      <select class="form-control" v-model="ethnicity_str" :disabled="processing" required>
                        <option value="" selected disabled>Ethnicity</option>
                        <option v-for="(val, key) in ethnicities" :key="key" :value="val">{{ val.name }}</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-md-4">
                    <label>Country <font color="red">*</font></label>
                    <div :class="{ 'control is-loading': processing }">
                      <select class="form-control" v-model="country" :disabled="processing" required>
                        <option value="" selected disabled>Select Country</option>
                        <option v-for="(val, key) in countries" :key="key" :value="val.id">{{ val.name }}</option>
                      </select>
                    </div>
                  </div>
                  <div class="form-group col-md-4">
                    <label>City <font color="red">*</font></label>
                    <div :class="{ 'control is-loading': processing }">
                      <select class="form-control" v-model="city" :disabled="processing" required>
                        <option value="" selected disabled>Select City</option>
                        <option v-for="(val, key) in cities" :key="key" :value="val.name">{{ val.name }}</option>
                      </select>
                    </div>
                  </div>
                  <div class="form-group col-md-4">
                    <label>States <font color="red">*</font></label>
                    <div :class="{ 'control is-loading': processing }">
                      <input type="text" class="form-control" placeholder="States" v-model="states" :disabled="processing"
                        required>
                    </div>
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-md-4">
                    <label>Phone Number</label>
                    <div :class="{ 'control is-loading': processing }">
                      <input type="text" class="form-control" placeholder="Phone Number" v-model="phone"
                        :disabled="processing">
                    </div>
                  </div>
                  <div class="form-group col-md-8">
                    <label>Additional Information</label>
                    <div :class="{ 'control is-loading': processing }">
                      <input type="text" class="form-control" placeholder="(Links to material in place of files)"
                        v-model="message" :disabled="processing">
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 text-center my-4">
                <label class="pr-2">Upload Image File(s) <font color="red">*</font></label>
                <button type="button" class="btn btn-idiom" @click="showAddImage = true"
                  :class="{ 'button is-loading': processing }">Add Image</button>
                <div class="row" v-if="image_files.length">
                  <div class="col-md-4 px-1 my-1 preview_image" v-for="(val, key) in image_files" :key="key">
                    <img :src="preview(val)" :alt="key">
                    <div class="btn-group" style="width:100%" role="group">
                      <button type="button" class="btn btn-sm btn-info" @click="PreviewImage(val)">
                        <i class="fas fa-search"></i>
                      </button>
                      <button type="button" class="btn btn-sm btn-danger" @click="RemoveImage(key)">
                        <i class="fas fa-trash"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 text-center my-4">
                <button type="submit" class="btn btn-idiom btn-round"
                  :class="{ 'button is-loading': processing }">Submit</button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <Footer />
    </div>

    <div class="modal" :class="{ 'is-active': showAddImage }">
      <div class="modal-background" @click="showAddImage = false"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Add Image(s)</p>
          <button class="delete" @click="showAddImage = false"></button>
        </header>
        <section class="modal-card-body">
          <div class="row">
            <label id="label_select_file" class="col-md-3">Select File</label>
            <div class="col-sm-7" :class="{ 'control is-loading': processing }">
              <input type="file" ref="file" accept="image/*" @change="onFileChange" class="form-control form-control-sm"
                style="height:40px">
            </div>
          </div>
        </section>
        <footer class="modal-card-foot row">
          <div class="col text-right">
            <button type="button" class="button" @click="showAddImage = false"
              :class="{ 'button is-loading': processing }">Close</button>
          </div>
        </footer>
      </div>
      <button class="modal-close is-large" aria-label="close" @click="showAddImage = false"></button>
    </div>

  </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue'
import Footer from '@/components/Footer.vue'
// import Multiselect from 'vue-multiselect'

export default {
  name: 'Submit',
  components: { Navbar, Footer/*, Multiselect*/ },
  data() {
    return {
      fname: "",
      lname: "",
      gender: "",
      email: "",
      city: "",
      country: "",
      states: "",
      age_range_str: "",
      ethnicity_str: "",
      phone: "",
      message: "",
      image_files: [],
      showAddImage: false,
      processing: false,
      // ................
      cities: [],
      countries: [],
      ethnicities: [],
      age_range: [
        { title: "0-5", begin: 0, to: 5 },
        { title: "5-10", begin: 5, to: 10 },
        { title: "10-15", begin: 10, to: 15 },
        { title: "15-18", begin: 15, to: 18 },
        { title: "18-25", begin: 18, to: 25 },
        { title: "25-30", begin: 25, to: 30 },
        { title: "30-35", begin: 30, to: 35 },
        { title: "35-40", begin: 35, to: 40 },
        { title: "40-45", begin: 40, to: 45 },
        { title: "45-55", begin: 45, to: 55 },
        { title: "55-65", begin: 55, to: 65 },
        { title: "65+", begin: 65, to: 99 },
      ]
    }
  },
  created() {
    this.cities = this.LocalStorage("_IdiomtalentDataCities", new Array());
    this.countries = this.LocalStorage("_IdiomtalentDataCountries", new Array());
    this.ethnicities = this.LocalStorage("_IdiomtalentDataEthnicities", new Array());
  },
  mounted() {
    if (!this.cities.length) this.get_cities();
    if (!this.countries.length) this.get_countries();
    if (!this.ethnicities.length) this.get_ethnicities();
  },
  methods: {
    async get_cities() {
      var url = this.api + 'dataOption/get_cities/' + this.secret;
      var data = new FormData();
      data.set('secret', this.secret);
      await this.Axios.post(url, data)
        .then((response) => {
          if (response.data.error == 0) {
            this.cities = response.data.data;
            localStorage.setItem("_IdiomtalentDataCities", JSON.stringify(response.data.data));
          }
        })
        .catch((error) => {
          alert(error);
          console.error(error);
        })
    },
    async get_countries() {
      var url = this.api + 'dataOption/get_countries/' + this.secret;
      var data = new FormData();
      data.set('secret', this.secret);
      await this.Axios.post(url, data)
        .then((response) => {
          if (response.data.error == 0) {
            this.countries = response.data.data;
            localStorage.setItem("_IdiomtalentDataCountries", JSON.stringify(response.data.data));
          }
        })
        .catch((error) => {
          alert(error);
          console.error(error);
        })
    },
    async get_ethnicities() {
      var url = this.api + 'dataOption/get_ethnicities/' + this.secret;
      var data = new FormData();
      data.set('secret', this.secret);
      await this.Axios.post(url, data)
        .then((response) => {
          if (response.data.error == 0) {
            this.ethnicities = response.data.data;
            localStorage.setItem("_IdiomtalentDataEthnicities", JSON.stringify(response.data.data));
          }
        })
        .catch((error) => {
          alert(error);
          console.error(error);
        })
    },
    onFileChange(e) {
      // console.log(e);
      this.image_files.push(e.target.files[0]);
      this.$refs.file.value = null;
      this.showAddImage = false;
    },
    preview(file) {
      return URL.createObjectURL(file);
    },
    PreviewImage(file) {
      window.open(URL.createObjectURL(file), 'PreviewImage', 'width=720,height=720')
    },
    RemoveImage(index) {
      this.$swal({
        title: "Are you sure?",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      })
        .then((willDelete) => {
          if (willDelete) {
            this.image_files.splice(index, 1);
          }
        });
    },
    async submitForm() {
      if (this.processing) return false;

      switch (true) {
        case (!this.image_files.length):
          this.$swal("Required Photo!", "Minimum require 1 photo!", "warning").then(() => { this.showAddImage = true; });
          return false;
        default:
          this.processing = true;
      }
      // return false;

      var url = this.api + 'models/submit_new/' + this.secret;
      var data = new FormData();
      data.set('fname', this.fname);
      data.set('lname', this.lname);
      data.set('gender', this.gender);
      data.set('email', this.email);
      data.set('age_begin', this.age_range_str.begin);
      data.set('age_to', this.age_range_str.to);
      data.set('ethnicity', this.ethnicity_str.name);
      data.set('city', this.city);
      data.set('country', this.country);
      data.set('states', this.states);
      data.set('phone', this.phone);
      data.set('message', this.message);
      this.image_files.forEach((e, i) => {
        console.log(e, i);
        data.append('file_' + i, e);
      });
      await this.Axios.post(url, data)
        .then((response) => {
          console.log(response.data);
          if (response.data.error == 0) {
            this.fname = "";
            this.lname = "";
            this.gender = "";
            this.email = "";
            this.age_range_str = "";
            this.ethnicity = [];
            this.city = "";
            this.country = "";
            this.states = "";
            this.phone = "";
            this.message = "";
            this.image_files = [];
            this.$swal("Success!", "", "success");
          } else {
            this.$swal("Error!", "", "success");
          }
        })
        .catch((error) => {
          this.$swal("", "", "warning");
          console.error(error);
        })
        .then(() => {
          this.processing = false;
        })
    }
  },
}
</script>

<!-- <style src="vue-multiselect/dist/vue-multiselect.min.css"></style> -->

<style scoped>
/* #main { background-color:#aa4d8e !important; } */
#main {
  background-color: #894073 !important;
}

#top h2 {
  text-align: right;
}

#detail {
  padding: 50px;
}

#detail small {
  font-size: 16px;
}

#label_select_file {
  padding-top: 9px;
  text-align: right;
}

#detail #desc {
  padding: 0 50px;
}

@media (max-width: 600px) {
  #top h2 {
    text-align: center;
    font-size: 22px;
  }

  #detail h2 {
    font-size: 18px;
  }

  #detail small {
    font-size: 14px;
  }

  #detail {
    padding: 25px;
  }

  #detail #desc {
    padding: 0;
  }

  #label_select_file {
    text-align: left;
  }
}

.preview_image img {
  height: 275px !important;
  width: 100% !important;
  object-fit: cover !important;
  /* object-position: 50% 50%; */
  /* object-position: 0 0; */
  object-position: 50% 0;
}</style>
